import React from 'react';

class FormatoSimplificado536878PlanBasico_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Formato Simplificado 536878 Plan Básico';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_FORMATO_SIMPLIFICADO_1345218_R_BASICO_2022_V1.pdf?alt=media&token=5d5bc1ad-c1ed-4bee-bd5c-59708c0046c2';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default FormatoSimplificado536878PlanBasico_pdf